<div *ngIf="user" class="rud-console">
  <ngx-loading [show]="isLoading"></ngx-loading>

  <!-- ── Console Top Bar ─────────────────────────────────────────────────── -->
  <div class="rud-console__topbar d-flex align-items-center gap-2">
    <span class="rud-console__led rud-console__led--green"></span>
    <span class="rud-console__led rud-console__led--amber"></span>
    <span class="rud-console__led rud-console__led--red"></span>
    <span class="rud-console__topbar-title ms-2">PLAYER PROFILE</span>
    <span class="rud-console__topbar-id ms-auto" *ngIf="user">
      ID:{{ user.cognitoId?.toString().substring(0, 8).toUpperCase() }}
    </span>
  </div>

  <!-- ── Stat Cards ──────────────────────────────────────────────────────── -->
  <section *ngIf="user" class="rud-console__stats mt-3">
    <div class="row g-2">
      <div class="col-12 col-sm-6 col-xl-3">
        <div class="rud-stat-card">
          <div class="rud-stat-card__label">
            <mat-icon class="rud-stat-card__icon">person</mat-icon>
            {{ 'ADMIN_REVIEW_USER.USER_NAME_TITLE' | translate }}
          </div>
          <div class="rud-stat-card__value">{{ user.username }}</div>
          <span class="rud-stat-card__corner">USR</span>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-xl-3">
        <div class="rud-stat-card">
          <div class="rud-stat-card__label">
            <mat-icon class="rud-stat-card__icon">vpn_key</mat-icon>
            {{ 'ADMIN_REVIEW_USER.KEYWORDS_TITLE' | translate }}
          </div>
          <div class="rud-stat-card__value">{{ user.keywords.join(', ') }}</div>
          <span class="rud-stat-card__corner">KWD</span>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-xl-3">
        <div class="rud-stat-card">
          <div class="rud-stat-card__label">
            <mat-icon class="rud-stat-card__icon">language</mat-icon>
            {{ 'ADMIN_REVIEW_USER.LOCALES_TITLE' | translate }}
          </div>
          <div class="rud-stat-card__value">{{ user.locales.join(', ') }}</div>
          <span class="rud-stat-card__corner">LOC</span>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-xl-3" *ngIf="user?.cmsUserData">
        <div class="rud-stat-card">
          <div class="rud-stat-card__label">
            <mat-icon class="rud-stat-card__icon">integration_instructions</mat-icon>
            {{ 'ADMIN_REVIEW_USER.CMS_INTEGRATIONS_TITLE' | translate }}
          </div>
          <div class="rud-stat-card__value">{{ cmsIntegrations }}</div>
          <span class="rud-stat-card__corner">CMS</span>
        </div>
      </div>
    </div>
  </section>

  <!-- ── Console Divider ────────────────────────────────────────────────── -->
  <div class="rud-console__divider d-flex align-items-center gap-2 my-3">
    <span class="rud-console__divider-line flex-grow-1"></span>
    <span class="rud-console__divider-label">SYS·DATA</span>
    <span class="rud-console__divider-line flex-grow-1"></span>
  </div>

  <!-- ── CRT Screen (Tab Group) ─────────────────────────────────────────── -->
  <section *ngIf="user" class="rud-console__screen-wrap">
    <!-- Screen bezel -->
    <div class="rud-console__bezel">
      <span class="rud-console__screw rud-console__screw--tl"></span>
      <span class="rud-console__screw rud-console__screw--tr"></span>
      <span class="rud-console__screw rud-console__screw--bl"></span>
      <span class="rud-console__screw rud-console__screw--br"></span>

      <div class="rud-console__screen">
        <!-- scanlines -->
        <div class="rud-console__scanlines" aria-hidden="true"></div>

        <mat-tab-group
          class="rud-console__tabs overflow-hidden"
          [selectedIndex]="selectedTab.value"
          (selectedIndexChange)="selectedTab.setValue($event)"
        >
          <!-- Achievements tab -->
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="rud-tab__icon">sports_esports</mat-icon>
              <span class="rud-tab__label">{{ 'LIST_ACHIEVEMENTS.TITLE' | translate }}</span>
              <button
                *ngIf="selectedTab.value === 0"
                mat-icon-button
                color="primary"
                (click)="onAddAchievement()"
                [title]="'ADMIN_REVIEW_USER.ADD_ACHIEVEMENT_BUTTON_TEXT' | translate"
              >
                <mat-icon>add_box</mat-icon>
              </button>
            </ng-template>
            <div class="rud-console__tab-body">
              <app-achievements-list [achievements]="achievements"></app-achievements-list>
            </div>
          </mat-tab>

          <!-- Statistics tab -->
          <mat-tab [label]="'ADMIN_REVIEW_USER.STATISTICS_TITLE' | translate">
            <div class="rud-console__tab-body">
              <app-my-statistics2
                [isActive]="selectedTab.value === 1"
                [title]="'ADMIN_REVIEW_USER.STATISTICS_TITLE'"
                [userId]="user.cognitoId"
              ></app-my-statistics2>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
      <!-- /.rud-console__screen -->
    </div>
    <!-- /.rud-console__bezel -->

    <!-- Screen footer bar -->
    <!-- <div class="rud-console__screen-footer d-flex align-items-center justify-content-between px-2 py-1">
      <span class="rud-console__screen-footer-label">◀ ▶ NAVIGATE</span>
      <span class="rud-console__screen-footer-label">● SELECT</span>
    </div> -->
  </section>

  <!-- ── System Alert ───────────────────────────────────────────────────── -->
  <div class="rud-console__alert d-flex align-items-center gap-2 mt-3" role="alert" *ngIf="errorMessage">
    <span class="rud-console__alert-led"></span>
    <mat-icon class="rud-console__alert-icon">error_outline</mat-icon>
    <span class="rud-console__alert-text">{{ errorMessage }}</span>
  </div>
</div>
